// extracted by mini-css-extract-plugin
module.exports = {"container":"Markdown-container-2is3Qc"};